import { useState, useEffect } from "react";
import address_book_img from "../../assets/icons/Address_Book_IMG.svg";
import add_recipient_btn_icon from "../../assets/icons/assignment_add.svg";
import SidePanel from "../../components/SidePanel";
import { Link } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import arrow_forward from "../../assets/icons/arrow_forward.svg";
import Upload_Picture from "../../assets/icons/Upload_Picture.svg";
import Spinner from "../../components/Spinner";
import remove_recipient from "../../assets/icons/remove_recipient.svg";
import GenerateCardPopup from "../../components/GenerateCardPopup";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoTrashBinOutline } from "react-icons/io5";
import { MdOutlineBuildCircle } from "react-icons/md";
import { toast } from "react-toastify";
import ConfirmationModal from "../../components/ConfirmationModal";
import { useMemo } from "react";

const RecipientCard = ({
  _id,
  fullName,
  gender,
  relationShip,
  dob,
  eventsId,
  profile_image,
  characterTraits,
  toggleRemoveModal,
  toggleOrderModal,
  setSelectedID,
  setSelectedCard,
  setSelectedCardID,
}) => {
  const age = Math.floor((new Date() - new Date(dob).getTime()) / 3.15576e10);

  return (
    <div className="bg-gray-100 lg:hover:border lg:hover:border-primary p-5 rounded-lg my-4 flex lg:flex-row flex-col items-center justify-between hover:shadow-md duration-150 ease-linear">
      {/* Profile Image Section */}
      <div className="flex lg:flex-row flex-col items-center lg:justify-start gap-5 w-full">
        <div
          className={`group w-[40%] h-48 rounded-lg bg-[#e5e8ea] ${
            profile_image ? "border-none" : "border border-dashed border-black"
          } flex items-center justify-center`}
        >
          {profile_image ? (
            <img
              src={profile_image}
              alt="Profile"
              className="w-full h-full object-cover rounded-lg duration-200 ease-linear"
            />
          ) : (
            <Link to={`/dashboard/address_book/edit/${_id}`}>
              <img
                src={Upload_Picture}
                alt="Upload Placeholder"
                className="duration-200 ease-linear cursor-pointer"
              />
            </Link>
          )}
        </div>

        {/* User Info Section */}
        <div className="text-base space-y-3 lg:w-1/2 w-full">
          <h3 className="font-bold text-secondary text-xl truncate">
            {fullName}
          </h3>
          <p className="bg-[#F39028] text-white capitalize text-sm px-5 py-1 rounded-full w-fit">
            {gender}
          </p>
          <p className="bg-green-700 text-white text-sm px-5 py-1 rounded-full w-fit">
            {age} Years Old
          </p>
          <p className="bg-pink-400 text-white text-sm px-5 py-1 rounded-full w-fit">
            {relationShip}
          </p>
        </div>
      </div>

      {/* Traits Section */}
      <div className="w-full lg:mt-0 mt-5 text-base text-secondary">
        <p className="mb-2 text-secondary text-lg font-semibold">Traits</p>
        <div className="flex flex-wrap gap-3 w-full">
          {characterTraits.map((trait, index) => (
            <button
              key={index}
              className="px-4 py-2 rounded-md bg-white hover:bg-slate-50 text-sm"
            >
              {trait}
            </button>
          ))}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="lg:w-1/4 w-full lg:mt-0 mt-5 space-y-3">
        <button
          onClick={() => {
            setSelectedID(_id);
            setSelectedCard(profile_image);
            setSelectedCardID(_id);
            toggleOrderModal();
          }}
          className="border border-primary text-primary hover:bg-primary-light py-2 w-full rounded-md flex items-center justify-center gap-x-2"
        >
          {/* <MdOutlineBuildCircle size={18} /> */}
          Generate
        </button>
        <Link to={`/dashboard/address_book/details/${_id}`}>
          <button className="border mt-2 border-primary text-primary hover:bg-primary-light py-2 w-full rounded-md flex items-center justify-center gap-x-2">
            {/* <IoMdInformationCircleOutline size={18} /> */}
            Details
          </button>
        </Link>
        <button
          onClick={() => {
            setSelectedID(_id);
            toggleRemoveModal();
          }}
          className="border border-primary bg-primary hover:bg-primary-dark text-white py-2 w-full rounded-md flex items-center justify-center gap-x-2"
        >
          {/* <IoTrashBinOutline size={16} /> */}
          Remove
        </button>
      </div>
    </div>
  );
};

const AddressBook = () => {
  const [recipients, setRecipients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRecipients, setFilteredRecipients] = useState([]);
  const [loader, setLoader] = useState(true);
  const [removeModal, setRemoveModal] = useState(false);
  const [isSorted, setIsSorted] = useState(false);
  const [sortedRecipients, setSortedRecipients] = useState([]);
  const [selectedID, setSelectedID] = useState(null);
  const [occasion, setOccasion] = useState([]);
  const [orderModal, setOrderModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedCardID, setSelectedCardID] = useState("");
  const [recipientsToDisplay, setRecipientsToDisplay] = useState([]);

  const sortRecipients = () => {
    if (!isSorted) {
      const sortedArray = [...recipients]; // Make a shallow copy of recipients
      setSortedRecipients(sortedArray); // Set the state with the sorted array (default order)
      setIsSorted(!isSorted);
    } else {
      const sortedArray = [...recipients].reverse(); // Reverse the order of the array
      setSortedRecipients(sortedArray); // Set the state with the reversed array
      setIsSorted(!isSorted);
    }
  };
  useEffect(() => {
    if (isSorted) {
      setRecipientsToDisplay(filteredRecipients);
    } else {
      setRecipientsToDisplay(sortedRecipients);
    }
  }, [sortedRecipients, isSorted, filteredRecipients]);

  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
  };

  const handleAddRecipient = () => {
    if (recipients.length < 3) {
      window.location.href = "/dashboard/address_book/add";
    } else {
      window.location.href = "/dashboard/premium_plan";
    }
  };

  const fetchRecipients = async (token) => {
    try {
      const customerId = localStorage.getItem("ID");
      if (!customerId || !token) {
        setLoader(false);
        return;
      }

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/get-customer-recipients/${customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );

      if (!res.ok) {
        throw new Error("Failed to fetch recipients");
      }

      const data = await res.json();
      setRecipients(data.data);
      setFilteredRecipients(data.data);
    } catch (error) {
      console.error("Error fetching recipients:", error);
      toast.error("Failed to fetch recipients");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const token = localStorage?.getItem("token");
    fetchRecipients(token);
  }, []);

  const handleDeleteRecipient = async (ID) => {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/recipient/delete-recipient/${ID}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      }
    );
    const res = await response.json();
    const status = res.code;

    if (status === 200) {
      const updatedRecipients = recipients.filter(
        (recipient) => recipient._id !== ID
      );
      setRecipients(updatedRecipients);
      setFilteredRecipients(updatedRecipients);
      toggleRemoveModal();
    } else if (
      status === 400 &&
      res.message === "Order is pending, deletion not allowed."
    ) {
      toast.error("Cannot delete recipient, pending or draft orders.");
      toggleRemoveModal();
    }
  };

  // const sortRecipients = () => {
  //   if (!isSorted) {
  //     console.log(recipients,"----------------")
  //     const sortedArray = [...recipients].sort((a, b) => {
  //       console.log(a, b,"aaaaaaaaaaaaaa");
  //       a.fullName.localeCompare(b.fullName);
  //     });
  //     setSortedRecipients(sortedArray);
  //   } else {
  //     setSortedRecipients([]);
  //   }
  //   setIsSorted(!isSorted);
  // };

  const toggleRemoveModal = () => {
    setRemoveModal(!removeModal);
  };

  useEffect(() => {
    const lowercasedSearch = searchTerm.toLowerCase();
    const filtered = recipients.filter(
      (recipient) =>
        recipient.fullName.toLowerCase().includes(lowercasedSearch) ||
        recipient.gender.toLowerCase().includes(lowercasedSearch) ||
        recipient.relationShip.toLowerCase().includes(lowercasedSearch) ||
        recipient.dob.includes(lowercasedSearch)
    );
    setFilteredRecipients(filtered);
  }, [searchTerm, recipients]);

  if (loader) {
    return (
      <section className="flex">
        <SidePanel />
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div
            className="w-full flex items-center justify-center"
            style={{ height: "calc(100vh - 10rem)" }}
          >
            <Spinner props={"Loading"} size={80} />
          </div>
        </div>
      </section>
    );
  }

  // const recipientsToDisplay = isSorted ? sortedRecipients : filteredRecipients;

  return (
    // <section className="flex max-w-[1200px] mx-auto">
    <section className="flex mx-auto px-4 sm:px-2">
      <SidePanel />
      {removeModal && (
        <ConfirmationModal
          title="Remove Recipient"
          message="Are you sure you want to remove this Recipient from Address Book?"
          imageSrc={remove_recipient}
          onConfirm={() => handleDeleteRecipient(selectedID)}
          onCancel={toggleRemoveModal}
          confirmText="Yes"
          cancelText="No"
          toggleModal={toggleRemoveModal}
        />
      )}

      {orderModal && (
        <GenerateCardPopup
          toggleOrderModal={toggleOrderModal}
          selectedCard={selectedCard}
          selectedCardID={selectedCardID}
          ID={selectedID}
        />
      )}
      {recipients.length === 0 ? (
        <div className="w-full  xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4 min-h-screen flex flex-col items-center justify-center">
          <div className="w-full">
            <div className="flex justify-between items-center flex-wrap">
              <h1 className="text-4xl text-secondary font-bold sm:text-left text-center mt-5">
                Address Book
              </h1>
              <button
                onClick={handleAddRecipient}
                className="flex items-center gap-x-3 sm:px-20 px-10 my-5 text-xl text-primary font-semibold py-2 rounded-md border-2 border-primary hover:bg-primary-light"
              >
                <img
                  src={add_recipient_btn_icon}
                  alt="add_recipient_icon"
                  className="w-6 sm:w-8"
                />
                Add Recipients
              </button>
            </div>

            <div className="flex flex-col items-center justify-center my-8 text-center">
              <img
                src={address_book_img}
                alt="Address_Book_IMG"
                className="w-full max-w-[300px] sm:max-w-[400px] md:max-w-[450px] lg:max-w-[450px] mb-4"
              />
              <h3 className="text-xl px-4">
                Add your favourite people in life to give them beautiful cards
              </h3>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div className="flex lg:flex-row flex-col items-center lg:items-start lg:justify-between justify-center w-full">
            {/* Heading */}
            <h1 className="text-3xl lg:text-4xl text-secondary font-bold text-center lg:text-left my-5 lg:my-0">
              Address Book
            </h1>

            {/* Action Buttons & Search */}
            <div className="flex lg:flex-row flex-col items-center justify-end gap-3 lg:w-[70%] w-full">
              {/* Search Input */}
              <div className="relative w-full lg:w-auto">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="bg-slate-50 text-lg shadow-md border-2 border-primary rounded-lg px-4 py-2 w-full lg:min-w-[300px]"
                />
                <IoIosSearch
                  size={24}
                  className="absolute text-primary inset-y-0 right-3 top-1/2 transform -translate-y-1/2"
                />
              </div>

              {/* Add Recipient Button */}
              <Link
                to="/dashboard/address_book/add"
                className="w-full lg:w-auto"
              >
                <button className="border-2 border-primary text-primary rounded-lg hover:bg-primary-light py-2 px-5 w-full lg:w-auto flex items-center justify-center gap-3">
                  <img
                    src={add_recipient_btn_icon}
                    alt="Add Recipient"
                    className="w-6 h-6"
                  />
                  <span className="text-base font-medium">Add Recipient</span>
                </button>
              </Link>

              {/* Sort Button */}
              <button
                onClick={sortRecipients}
                className={`${
                  isSorted ? "bg-primary-dark" : "bg-primary"
                } text-white py-2 px-5 w-full lg:w-auto rounded-lg flex items-center justify-center gap-3`}
              >
                <img src={arrow_forward} alt="Sort" className="w-6 h-6" />
                <span className="text-base font-medium">Sort</span>
              </button>
            </div>
          </div>

          {recipientsToDisplay.length
            ? recipientsToDisplay?.map((recipient) => (
                <RecipientCard
                  {...recipient}
                  key={recipient._id}
                  toggleRemoveModal={toggleRemoveModal}
                  toggleOrderModal={toggleOrderModal}
                  setSelectedID={setSelectedID}
                  setSelectedCard={setSelectedCard}
                  setSelectedCardID={setSelectedCardID}
                />
              ))
            : filteredRecipients?.map((recipient) => (
                <RecipientCard
                  {...recipient}
                  key={recipient._id}
                  toggleRemoveModal={toggleRemoveModal}
                  toggleOrderModal={toggleOrderModal}
                  setSelectedID={setSelectedID}
                  setSelectedCard={setSelectedCard}
                  setSelectedCardID={setSelectedCardID}
                />
              ))}
        </div>
      )}
    </section>
  );
};

export default AddressBook;
